import { faPaperPlane } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useRef, useState } from "react";
import { Button, Card, Container, Form, Row, Toast, ToastContainer } from "react-bootstrap"
import { Link } from "react-router-dom";
import { authService } from "../../services/AuthService";
import { MakeMessageError } from "../../components/Components";
import { aguardar } from "../../utils/utils";
import { navigateTo } from "../../utils/navigation";
import { BoxArrowRight } from "react-bootstrap-icons";

const initialErrorState = {
    email: [],
}

export const ForgotPasswordForm: React.FC = () => {
    const [email, setEmail] = useState<string>('');
    const [mensagem, setMensagem] = useState<string>('');
    const [showMessage, setShowMessage] = useState<boolean>(false);
    const [showError, setShowError] = useState<boolean>(false);
    const btnEnviar = useRef<HTMLButtonElement>(null);
    const [errors, setErrors] = useState(initialErrorState);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        btnEnviar.current?.setAttribute('disabled', 'disabled');
        
        await authService.forgotPassword(email)
            .then(async (res: any) => {
                setMensagem('Abra seu e-mail para alterar a senha.');
                setShowMessage(true);
                await aguardar(2);
                navigateTo('/login');
                btnEnviar.current?.removeAttribute('disabled');
                
            })
            .catch((error: any) => {
                if (error.status === 400) {
                    setMensagem(error.response.data.message);
                    setShowError(true);
                } else if (error.status === 422) {
                    setErrors(error.response.data);
                } else {
                    setMensagem('Erro no servidor.');
                    setShowError(true);
                }
                btnEnviar.current?.removeAttribute('disabled');
            })
        
    }

    return (
        <div className="bg-light" style={{
            alignItems: 'center', 'display': 'flex',
            flexDirection: 'column', 'height': '100vh', justifyContent: 'center'
        }}>
            <Container className="justify-content-center" style={{ maxWidth: '400px', }}>
                <ToastContainer position="top-end" className="p-3" style={{ zIndex: 1 }}>
                    <Toast bg="light" onClose={() => setShowMessage(false)} show={showMessage} delay={5000} autohide>
                        <Toast.Header>
                            <strong className="me-auto">Aviso!</strong>
                        </Toast.Header>
                        <Toast.Body className="text-dark fw-bold">{mensagem}</Toast.Body>
                    </Toast>

                    <Toast bg="danger" onClose={() => setShowError(false)} show={showError} delay={4000} autohide>
                        <Toast.Header>
                            <strong className="me-auto">Error!</strong>
                        </Toast.Header>
                        <Toast.Body className="text-light fw-bold">{mensagem}</Toast.Body>
                    </Toast>


                </ToastContainer>
                <Form onSubmit={handleSubmit}>
                    <Card className="card-primary card-outline">
                        <Card.Header >
                            <h5 className="m-2">
                                Esqueci a senha
                            </h5>

                        </Card.Header>
                        <Card.Body>
                            <Row className="g-2">
                                <Form.Group>
                                    <Form.Control
                                        placeholder="Digite seu e-mail"
                                        value={email}
                                        name="email"
                                        onChange={(e: any) => {
                                            const { name, value } = e.target;
                                            setErrors(prev => ({ ...prev, [name]: "" }));
                                            setEmail(value);
                                        }}
                                        type="email"
                                    />
                                    <MakeMessageError errors={errors} field="email" />
                                </Form.Group>
                            </Row>
                        </Card.Body>
                        <Card.Footer>
                            <div className="d-flex justify-content-between">
                                <Link to="/login" className="">
                                    <Button variant="secondary" className="ms-2">
                                        <BoxArrowRight className="" /> Login
                                    </Button>
                                </Link>
                                <Button type="submit" ref={btnEnviar}>
                                    <FontAwesomeIcon icon={faPaperPlane} /> Enviar link
                                </Button>
                            </div>
                        </Card.Footer>
                    </Card>
                </Form>
            </Container>
        </div>
    )
}